import {CreateSuperadminNewsPayload} from 'src/interfaces/SuperadminNews.interface'
import {NewsUpdateFormValues} from './NewsUpdateForm'

export const buildNotificationPayload = (values: NewsUpdateFormValues): CreateSuperadminNewsPayload => ({
  title: values.heading.trim(),
  description: values.description.trim(),
  type: values.type,
  feature_released_date: values.releaseDate,
})
